/*
 * @Author: YuanYuan
 * @Date: 2025-08-20 09:36:58
 * @LastEditTime: 2025-09-09 16:34:37
 * @Description: 渠道商路由
 */
import i18n from '@/i18n'

const Meta = {
  leftMenuCode: 'Distributor'
}

export default [
  {
    path: '/distributor/overview',
    meta: {
      ...Meta,
      title: i18n.t('menu.overview')
    },
    component: () => import('@/views/distributor/overview.vue')
  },
  {
    path: '/distributor/info',
    meta: {
      ...Meta,
      title: i18n.t('menu.channelInfoMngmt')
    },
    component: () => import('@/views/distributor/info.vue')
  },
  {
    path: '/distributor/customers',
    meta: {
      ...Meta,
      title: i18n.t('menu.customerMngmt')
    },
    component: () => import('@/views/distributor/customers.vue')
  },
  {
    path: '/distributor/customer/orders',
    meta: {
      ...Meta,
      leftActiveIndex: '/distributor/customers',
      backable: true,
      title: i18n.t('distributor.orderList')
    },
    component: () => import('@/views/distributor/customerOrders.vue')
  },
  {
    path: '/distributor/customer/transfer',
    meta: {
      ...Meta,
      leftActiveIndex: '/distributor/customers',
      backable: true,
      title: i18n.t('distributor.transfer')
    },
    component: () => import('@/views/distributor/transfer.vue')
  },
  {
    path: '/distributor/orders',
    meta: {
      ...Meta,
      title: i18n.t('menu.customerOrders')
    },
    component: () => import('@/views/distributor/orders.vue')
  },
  {
    path: '/distributor/order/detail',
    meta: {
      ...Meta,
      leftActiveIndex: '/distributor/orders',
      title: i18n.t('orders.orderDetails'),
      backable: true
    },
    component: () => import('@/views/orders/orderDetail.vue')
  },
  {
    path: '/distributor/daily/detail',
    meta: {
      ...Meta,
      leftActiveIndex: '/distributor/orders',
      title: i18n.t('orders.orderDetails'),
      backable: true
    },
    component: () => import('@/views/orders/dailyDetail.vue')
  }
]
